import { render } from "./PaymentHistoryTable.vue?vue&type=template&id=90083972&scoped=true"
import script from "./PaymentHistoryTable.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryTable.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-90083972"

export default script